
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="px-6 py-6">
        <div className="flex items-center justify-between gap-8">
          <a href="/" className="flex items-center gap-4 cursor-pointer">
            <div className="w-[140px] h-[140px] flex items-center justify-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/07ad7141c311a7160b38f0cefce25ed0/fff9872d1e4dea0a924b1029418952c7.png"
                alt="Dr. Savai Consulting Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <span className={`text-3xl font-bold ${scrolled ? 'text-charcoal' : 'text-charcoal'}`}>
              Dr. Savai Consulting
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="text-charcoal hover:text-primary transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              About
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-charcoal hover:text-primary transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              Services
            </button>
            <span className="text-gray-300">•</span>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-charcoal hover:text-primary transition-colors cursor-pointer whitespace-nowrap text-base"
            >
              Contact
            </button>
          </div>

          <button 
            onClick={() => scrollToSection('contact')}
            className="bg-primary text-white px-8 py-3 rounded-lg hover:bg-primary/90 transition-all hover:shadow-lg cursor-pointer whitespace-nowrap text-base"
          >
            Start Learning
          </button>
        </div>
      </div>
    </nav>
  );
}
